<p-autoComplete [(ngModel)]="partner" (ngModelChange)="partnerChange.emit($event)"
                name="partner" [disabled]="mode !== DetailMode.EDITION"
                [required]="required" class="acted-highlight-req metadata-field"
                [suggestions]="allPartners" optionLabel="name" (completeMethod)="getPartnerSuggestions($event)"
                [multiple]="false" [forceSelection]="true"
                [dropdown]="false" dropdownMode="current" i18n-placeholder="@@common-none" placeholder="(none)"
                appendTo="body" [tabindex]="tabindex">
</p-autoComplete>
<!-- Put back [minQueryLength]="2" once this bug is fixed: https://github.com/primefaces/primeng/issues/19218           -->
